export default __webpack_public_path__ + "static/media/Weak area.ec59eb85.gif";